import { TOUR_TRANSLATIONS } from "../translations"

export const getShareOfBrowseSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="share-browse-table"]',
            title: t.shareBrowseTable.title,
            content: t.shareBrowseTable.content,
            disableBeacon: true,
        },
    ]
}
